export default __webpack_public_path__ + "static/media/wave2.fc70d10e.svg";